/* eslint-disable */
import React from 'react'
import { useTranslation } from 'react-i18next';

// MUI
import LaunchIcon from '@mui/icons-material/Launch';
import { PhotoCamera } from '@mui/icons-material';

// Custom
import MapCardActionButton from '@/ui/MapCard/MapCardActionButton';
import Permissions from '@/lib/permissions';

// Types
import { TCustomGFIActionProps } from '@/@types/views/map'

const ShowPhotodocButton = (props: TCustomGFIActionProps) => {

    const { t } = useTranslation();

    const { featureData, layerIndex = 0, type } = props;

    const handleShowPhotodoc = () => {
        const properties = featureData.features[layerIndex].properties;
        const id = type === 'grobno_mjesto' ? properties.id : properties.objekt_id;

        const basePath = type === 'grobno_mjesto' ? 'groblja' : 'ena';

        if (id) {
            const url = `${location.origin}/${basePath}/photodoc/?rec_id=${id.toString()}`;
            window.open(url, '_blank');
        }
    };

    return (
        <MapCardActionButton
            startIcon={<PhotoCamera />}
            onClick={handleShowPhotodoc}
            aria-label="photo"
            disabled={false}
            needPermission={type === 'grobno_mjesto' ? [Permissions.Groblja] : [Permissions.Ena]}
            tooltip='tooltips.buttons.show_photos'
        >
            {t('buttons.show_photos')}
            <LaunchIcon
            style={{ marginLeft: '7px', width: '16px', height: '16px' }}
            />
        </MapCardActionButton>
    )
}

export default ShowPhotodocButton